<template>
    <div class="sidebarFilters">
        <div class="sidebarFilters__title">{{ gettext('Фильтры') }}</div>
        <div class="sidebarFilters__list">
            <label v-if="isShowFilter('keyword_q')">
                <div>{{ gettext('Фильтр по ключевику (вхождение)') }}</div>
                <input type="text" name="keyword_q" @change="changeQueryParam">
            </label>
            <label v-if="isShowFilter('keyword')">
                <div>{{ gettext('Фильтр по ключевику (точное совпадение)') }}</div>
                <input type="text" name="keyword" @change="changeQueryParam">
            </label>
            <label v-if="isShowFilter('source_id')">
                <div>{{ gettext('Источник отзывов') }}</div>
                <select name="source_id" @change="changeQueryParam">
                    <option selected value="null">{{ gettext('Показывать все') }}</option>
                    <option v-for="source in sourcesList" :key="source.id" :value="source.id">{{ source.title }}</option>
                </select>
            </label>
            <label v-if="isShowFilter('branch_name')">
                <div>{{ gettext('Филиал') }}</div>
<!--                <input type="text" name="branch_name" @change="changeQueryParam">-->
                <select name="branch_name" @change="changeQueryParam">
                    <option selected value="null">{{ gettext('Показывать все') }}</option>
                    <option v-for="branch in branchesList" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                </select>
            </label>
            <label v-if="isShowFilter('date')">
                <div>{{ gettext('На дату') }}</div>
                <input type="text" name="date" @change="changeQueryParam">
            </label>
<!--            <label v-if="isShowFilter('sources')">-->
<!--                <div>Источники</div>-->
<!--                <select name="sources" @change="changeQueryParam">-->
<!--                    <option v-for="source in sourcesList" :key="source.id" :value="source.id">{{ source.title }}</option>-->
<!--                </select>-->
<!--            </label>-->
        </div>
    </div>
</template>

<script>

export default {
    name: 'FilterBlock',
    props: {
        query: {
            type: Object,
            required: true,
        },
        filters: {
            type: Array,
            required: true,
            default: function () {
                return []
            }
        }
    },
    data: () => ({

    }),
    computed: {
        branchesList() {
            return this.$store.getters.branchesList
        },
        sourcesList() {
            return this.$store.getters.sourcesList
        },
        currentPageQuery() {
            return this.$store.state.currentPageQuery
        },
    },
    watch: {
        currentPageQuery() {
            this.handleUrlQueryParams()
        },
    },
    methods: {
        changeQueryParam(event) {
            const target = event.target
            this.query.setQueryParam({key: target.name, value: target.value})
            this.$emit('filterQueryParamChanged', {key: target.name, value: target.value})
        },
        isShowFilter(filterName) {
            return !!~this.filters.indexOf(filterName)
        },
        handleUrlQueryParams() {
            const queryGetParams = this.$store.state.currentPageQuery._params._params
            
            for (const key in queryGetParams) {
                // eslint-disable-next-line no-prototype-builtins
                if(!queryGetParams.hasOwnProperty(key)) continue;

                if (~this.filters.indexOf(key)) {
                    setValue.call(this, key, queryGetParams[key])
                }
            }
            
            function setValue(key, value) {
                const element = this.$el.querySelector(`[name=${key}]`)
                element.value = value
            }
        },
    },
}

</script>

<style lang="less">
    .sidebarFilters {
    
    }
    .sidebarFilters__title {
        font-size: 14px;
        font-weight: 700;
    }
    
    .sidebarFilters__list {
        label, input {
            display: block;
        }
        
        input {
            &:hover, &:focus, &:active {
                box-shadow: 0 0 3px #ccc;
            }
        }
        
        label > div {
            line-height: 1.4;
            font-size: 12px;
        }
        label input, label select {
            display: block;
            width: 100%;
            outline: none;
            border: 1px;
            border-radius: 3px;
            padding: 4px 8px;
            box-shadow: 0 0 3px #ccc;
            margin-top: 4px;
            font-size: 0.9em;
            color: #777;
        }
    }
</style>